// QRCodeGenerator.jsx

import React, { useState, useEffect } from 'react';
import axios from 'axios';

function QRCodeGenerator({ data }) {
    const [qrCodeImage, setQRCodeImage] = useState('');

    useEffect(() => {
        const generateQRCode = async () => {
            try {
                const response = await axios.get(`/generateQRCode?data=${data}`);
                setQRCodeImage(response.data);
            } catch (error) {
                console.error('Error generating QR code:', error);
            }
        };

        if (data) {
            generateQRCode();
        }
    }, [data]);

    return (
        <div>
            {qrCodeImage && <img src={qrCodeImage} alt="QR Code" />}
        </div>
    );
}

export default QRCodeGenerator;
